import React, { useEffect, useState } from 'react'

function ProductImage({product}) {
  // console.log(product)
  const [mainImage, setMainImage] = useState(product.featuredImage.url)

  useEffect(() => {
    setMainImage(product.featuredImage.url)
  },[product])
  return (
    <div className="relative flex md:flex-row-reverse flex-col justify-start items-start gap-2 image-container">
    <img className="pt-2 w-full md:w-[80%]" src={mainImage} alt={product.name} />
    <div className="items-start gap-2 grid grid-cols-4 md:grid-cols-1 py-2 cursor-pointer images-container">
      {product.images.nodes.slice(0,4).map((item) => {
       return <img key={item.id} onClick={() => setMainImage(item.url)} className="w-auto" src={item.url} alt={product.name} />
      })}
    </div>
    {/* <img
      className="top-0 left-0 absolute opacity-0 group-hover:opacity-100 w-full transition-opacity duration-300"
      src={`/${product?.image[1]}`}
      alt={product.name}
    /> */}
  </div>
  )
}

export default ProductImage

/* old code
    <div className="relative image-container">
    <img className="w-full" src={`${product?.image[0]}`} alt={product.name} />
    <img
      className="top-0 left-0 absolute opacity-0 group-hover:opacity-100 w-full transition-opacity duration-300"
      src={`/${product?.image[1]}`}
      alt={product.name}
    />
  </div>*/